import { t } from "i18next";

export default function ActivityStringHelper(activity: string) {

    switch (activity) {
        case '5':
            return t('doctor');
        case '6':
            return t('holiday');
        case '7':
            return t('illness');
        case '11':
            return t('spareHoliday');
        case '13':
            return t('unpaid');
        default:
            return '-';
    }
}